<template>
  <div class="pre-translation">

    <!-- <div class="title">{{$t('newProjectV2.transMemoryBank')}}</div>
    <div class="content">
      <el-checkbox @change="handleModel" v-model="memoryBankModel">{{$t('newProjectV2.transMemoryBankItem')}}</el-checkbox>
    </div>

    <div class="title">{{$t('newProjectV2.machineTrans')}}</div>
    <div class="content">
      <el-checkbox @change="handleModel" v-model="machineModel">{{$t('newProjectV2.machineTransItem')}}</el-checkbox>
    </div>

    <div class="title">{{$t('newProjectV2.sentStates')}}</div>
    <div class="content">
      <el-checkbox @change="handleModel" v-model="memoryBankMatch">{{$t('newProjectV2.sentStatesItem')}}</el-checkbox>
    </div>

    <div class="title">{{$t('newProjectV2.lockRepeat')}}</div>
    <div class="content">
      <el-checkbox @change="handleModel" v-model="lockRepeat">{{$t('newProjectV2.filelockRepeat')}}</el-checkbox>
    </div> -->
    <ul>
      <li>
        <div class="title">{{$t('newProjectV2.transMemoryBank')}}<el-switch @change="handleModel" v-model="memoryBankModel" active-color="#0078FC" inactive-color="#DCDCDC"></el-switch></div>
        <div class="content">{{$t('newProjectV2.transMemoryBankItem')}}</div>
      </li>
      <li>
        <div class="title">{{$t('newProjectV2.machineTrans')}}<el-switch @change="handleModel" v-model="machineModel" active-color="#0078FC" inactive-color="#DCDCDC"></el-switch></div>
        <div class="content">{{$t('newProjectV2.machineTransItem')}}</div>
      </li>
      <!-- <li>
        <div class="title">{{$t('newProjectV2.sentStates')}}<el-switch @change="handleModel" v-model="memoryBankMatch" active-color="#0078FC" inactive-color="#DCDCDC"></el-switch></div>
        <div class="content">{{$t('newProjectV2.sentStatesItem')}}</div>
      </li>
      <li>
        <div class="title">{{$t('newProjectV2.lockRepeat')}}<el-switch @change="handleModel" v-model="lockRepeat" active-color="#0078FC" inactive-color="#DCDCDC"></el-switch></div>
        <div class="content">{{$t('newProjectV2.filelockRepeat')}}</div>
      </li> -->
    </ul>

  </div>
</template>

<script>
export default {
  name: 'PreTranslation',
  props: {
    preTransList: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      memoryBankModel: this.preTransList.memoryBankModel,       // 翻译记忆库
      machineModel: this.preTransList.machineModel,             // 机器翻译
      memoryBankMatch: this.preTransList.memoryBankMatch,       // 将以下句段状态设置为已确认
      lockRepeat: this.preTransList.lockRepeat,
    }
  },
  methods: {
    handleModel (index) {
      // switch (index) {
      //   case 1:
      //     this.memoryBankModel = !this.memoryBankModel;
      //     break;
      //   case 2:
      //     this.machineModel = !this.machineModel;
      //     break;
      //   case 3:
      //     this.memoryBankMatch = !this.memoryBankMatch;
      //     break;
      //   case 4:
      //     this.lockRepeat = !this.lockRepeat;
      // }
      this.$emit('getPreTransList', {
        memoryBankModel: this.memoryBankModel,
        machineModel: this.machineModel,
        memoryBankMatch: this.memoryBankMatch,
        lockRepeat: this.lockRepeat,
      });
    }
  }
}
</script>

<style lang="less" scoped>
  @import "./assets/style.less";
</style>